/**
 * @format
 * @module lib/financial/valuengine-report
 */
import tgamConfig from "config/tgam";
import { getProp, qsa } from "utils/utils";
import { isOnDemand, isSubscribed, isRegistered } from "lib/identity/api";
import { constructQuery } from "utils/urls";
import { AWS_VALUENGINE } from "lib/amazon-web-services";

/**
 * @method init
 * @description Initializes the "ValueEngine Reports" card and download link
 */
export default function init() {
  const links = qsa(".js-valuengine-link");

  if (links.length > 0 && (isRegistered() || isSubscribed() || isOnDemand())) {
    const hashId = getProp(tgamConfig, "datalayer.identity.guid", "");
    links.forEach(link => {
      const query = constructQuery(
        {
          symbol: encodeURIComponent(link.dataset.symbol || ""),
          region: encodeURIComponent(link.dataset.region || ""),
          uid: !hashId && isOnDemand() ? "ipring" : encodeURIComponent(hashId)
        },
        true
      );
      link.setAttribute("href", AWS_VALUENGINE + "?" + query);
    });
  }
}
